import { createUrlQueryString, prepareUrl } from '@/helpers/UrlHelpers';
import ApiEndpoints from '@/config/ApiEndpoints';
import ApiService from '@/services/ApiService';

export default class FetchUserOrders {
    /**
     * ApiService instance.
     *
     * @var {ApiService}
     */
    apiService

    /**
     * FetchUserOrders constructor.
     *
     * @param {ApiService|null} apiService
     *
     * @returns {void}
     */
    constructor(apiService = null) {
        this.apiService = apiService || new ApiService(process.env.VUE_APP_API_URL);

        this.apiService.enableAuth();
    }

    /**
     * Get all the user's orders.
     *
     * @param {number} userId
     * @param {number} page
     *
     * @returns {Promise}
     */
    handle(userId, page) {
        let apiUrl = prepareUrl(ApiEndpoints['orders.users.orders.index'], [userId]) +
            '?' + createUrlQueryString({ page: page });

        return this.apiService.get(apiUrl);
    }
}
